import React from 'react'

import { cn } from '@/lib/utils'
import ProjectDataGrid from './ProjectDataGrid'
import { Card } from '../ui/Card'

/**
 * ProjectPanel
 *
 * Adapted from the design firm's `ProjectPanel` in the data-grid concept app.
 * This focuses on the container/header/agent-status UX while keeping
 * implementation light and compatible with the existing tracker app.
 *
 * A real data grid (TanStack Table, filters, views, etc.) can be layered in
 * later without changing this shell.
 */
const ProjectPanel = ({ agent, className }) => {
  const safeAgent = agent || { isBusy: false, lastAction: '' }

  return (
    <Card
      className={cn(
        'relative flex h-full min-h-[520px] flex-col overflow-hidden rounded-2xl shadow-lg',
        'backdrop-blur-md',
        className,
      )}
    >
      <header className="flex flex-wrap items-start justify-between gap-3 px-5 py-3">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
            Project Pilot
          </p>
          <div className="mt-1 flex items-center gap-2">
            <h2 className="text-2xl font-semibold leading-tight text-primary">
              Tracker
            </h2>
            <span
              className="h-2 w-2 rounded-full bg-emerald-500"
              aria-hidden="true"
            />
          </div>
        </div>
        <div className="rounded-2xl border border-border/60 px-4 py-3 text-xs text-muted-foreground">
          <p>
            {safeAgent.isBusy ? 'Working' : 'Idle'}
            {safeAgent.lastAction ? ` • ${safeAgent.lastAction}` : ''}
          </p>
        </div>
      </header>
      <div className="relative flex-1 min-h-0 px-5 pb-5 pt-4">
        {/* Sparkle/aurora layer */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 -z-10 grid-sparkle"
        />

        <div className="grid-frame flex h-full min-h-0 flex-col gap-3 rounded-xl p-3">
          {/* Main grid area: live project table */}
          <ProjectDataGrid />
        </div>
      </div>
    </Card>
  )
}

export default ProjectPanel
